import React from 'react';
import { useNavigate, Link } from 'react-router-dom';

const HERO_IMAGE =
  'https://images.unsplash.com/photo-1667312939978-64cf31718a6e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHx3YXJtJTIwbWluaW1hbCUyMGludGVyaW9yJTIwc3RpbGwlMjBsaWZlJTIwYm9va3MlMjBjZXJhbWljJTIwYm93bCUyMGxhbXB8ZW58MHx8fHwxNzg3NjQ5MjE0fDA&ixlib=rb-4.1.0&q=85&w=1200';

export const Welcome = () => {
  const navigate = useNavigate();

  return (
    <div className="page welcome-page" data-testid="welcome-page">
      <div className="welcome-content">
        <span className="welcome-brand">irecommend</span>
        <h1 className="welcome-title">Recommendations you can trust.</h1>
        <p className="welcome-sub">
          Save and discover recommendations from people you know and trust.
        </p>
        <button
          className="welcome-btn"
          onClick={() => navigate('/signin')}
          data-testid="welcome-signin"
        >
          Sign in
        </button>
        <p className="welcome-note">irecommend is invite only.</p>
        <p className="legal-links" data-testid="welcome-legal-links">
          <Link className="legal-links-item" to="/privacy" data-testid="welcome-privacy-link">
            Privacy Statement
          </Link>
          <span className="legal-links-sep" aria-hidden="true">
            ·
          </span>
          <Link className="legal-links-item" to="/terms" data-testid="welcome-terms-link">
            Terms of Use
          </Link>
        </p>
      </div>

      <div className="welcome-visual" data-testid="welcome-visual">
        <img src={HERO_IMAGE} alt="" loading="eager" />
      </div>
    </div>
  );
};
